import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/punto-de-venta/configuraciones/clientes',
  documento: 'pos-settings',
  acceso: 'sesion',
  filas: ['015'],
  cita: 'Areas/POS_Settings/Controllers/SettingsController.cs:116',
} satisfies RutaProd;
